import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["canvas", "input"]
  start(event) {
    event.preventDefault()
    this.drawing = true
    this.canvasTarget.setPointerCapture(event.pointerId)
    const ctx = this.canvasTarget.getContext("2d")
    ctx.lineWidth = 2
    ctx.beginPath()
    const [x, y] = this.point(event)
    ctx.moveTo(x, y)
    ctx.lineTo(x + 0.1, y + 0.1)
    ctx.stroke()
  }
  draw(event) {
    if (!this.drawing) return
    const ctx = this.canvasTarget.getContext("2d")
    ctx.lineTo(...this.point(event))
    ctx.stroke()
  }
  finish() {
    if (!this.drawing) return
    this.drawing = false
    this.inputTarget.value = this.canvasTarget.toDataURL("image/png")
  }
  clear() {
    this.canvasTarget.getContext("2d").clearRect(0, 0, 600, 150)
    this.inputTarget.value = ""
  }
  point(event) {
    const rect = this.canvasTarget.getBoundingClientRect()
    return [(event.clientX - rect.left) * 600 / rect.width, (event.clientY - rect.top) * 150 / rect.height]
  }
}
